import React from 'react';

const Fieldset = ({ className='', title='', children, ...props }) => {

  return (<div className={`fieldset ${className}`} {...props}>
    {title !== '' && <h3 className="fieldset__title">{title}</h3>}
    <div className="fieldset__inner">{children}</div>
  </div>);
}

export default Fieldset;